import {Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ElementRef, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksToolbarSettings} from "../../models/stocks-toolbar-settings";
import {MainHelper} from "../../models/main-helper";
import {OnDropdownFilteredEventArgs} from "../../../slick-grid/models/on-dropdown-filtered-event-args";
import {AggregationSelector} from "../../../stocks/models/aggregation-selector";
import {StocksToolbarHelper} from "../../models/stocks-toolbar-helper";

export enum ToolbarState {
    Opened = 0,
    Fixed = 1,
    Closed = 2
}


@Component({
    selector: 'stocks-toolbar',
    templateUrl: './stocks-toolbar.component.html',
    styleUrls: ['../../../shared/styles/custom-scroll.css', './stocks-toolbar.component.css']
})
export class StocksToolbarComponent implements OnInit, AfterViewInit{

    constructor(public readonly translateService: TranslateService,
                ){
        this.locale = localStorage['UserLocale'];
        this.emitter  = new EventEmitter<{cmd: string, data: any}>();
        this.helper = new MainHelper();
    }

    @Input() popperWrapper: HTMLElement;
    @Input() popperWrapperId: string;
    @Input() tbh: StocksToolbarHelper<any>;
    @Input() settings: StocksToolbarSettings[];

    get language(): string{
        return this.locale;
    }

    set language(value: string){
        this.locale = value;
        localStorage['UserLocale'] = value;
    }

    private lastPosition: number;

    @Output() emitter: EventEmitter<{cmd: string, data: any}>;

    private locale: string;
    public helper: MainHelper;

    @ViewChild('addGroupingBtn')
    public addGroupingBtnRef: ElementRef;

    @ViewChild('addAggregationBtn')
    public addAggregationBtnRef: ElementRef;

    @ViewChild('remFiltersBtn')
    public remFiltersBtnRef: ElementRef;

    ngOnInit(){
        if (!this.settings){
            this.settings = [];
        }

        this.tbh.dataWorkZoneEm.subscribe( r => this.updateExpand(null));
        this.settings && this.settings.length > 1
            ? this.lastPosition = this.helper.getMaxOfArray(this.settings.map((s: StocksToolbarSettings)  => s.position))
            : this.lastPosition = 0;

        // this.lastPosition = --this.lastPosition;
        // console.log(this.lastPosition, 'this.lastPosition')
    }

    ngAfterViewInit(){

    }

    private updateExpand = (zone: StocksToolbarSettings): void => {
        if (zone){
            if (zone.expanded){
                this.settings.forEach(s => {s.hide = false; s.expanded = false});
            } else {
                this.settings.forEach(s => {
                    if (s.zoneId !== zone.zoneId && s.canHideOnExpand){
                        s.hide = true;
                    } else {
                        s.hide = false;
                    }
                });
            }
            zone.expanded = !zone.expanded;
        } else {
            if (this.tbh.dataWorkZone) {
                this.settings.forEach(s => {
                    if (s.canHideOnExpand){
                        s.hide = true;
                    }
                });
            } else {
                this.settings.forEach(s => s.hide = false);
            }
        }
    }

    public setWidthForWorkDataZone = (): number => {
        return 100/(+this.tbh.showGroupings + +this.tbh.showAggregations + +this.tbh.showFilters)
    }

    public emit = (data: { cmd: string, data: any}, openToolbar: boolean = false): void => {
        openToolbar && this.tbh.toolbarHidden && this.tbh.controlToolbar();
        this.emitter.emit(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/stocks-toolbar.component/stocks-toolbar.component.ts